import React, { useCallback, useState } from "react";
import axiosInstance from "./base/axios";

const PutHooks = () => {
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState();

  const callApi = useCallback(async (pro) => {
    setLoading(true);
    try {
      const res = await axiosInstance.put(pro.url, pro.body);
      setData(res);
      return res;
    } catch (err) {
      setData(err);
      console.log("err", err);
      // errorToast(err.response.data.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return [isLoading, data, callApi];
};

export default PutHooks;
